// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"O5-z","dimensionLabel":"P5-z","styleChooserControlWrapper":"Q5-z","styleChooserControl":"R5-z","disabled":"S5-z","giftCard":"T5-z","styleChooserText":"U5-z"};